// Available Endorsements Response (POST applications/availableEndorsements) - EPLI has options object
// {
//   "availableEndorsements": {
//     "cyberCoverage": "{\"limits\":\"25000/50000\"}",
//   },
// }
//
// Application Update Payload (POST applications)
// {
//    cyberCoverage: {
//        limits: '25000/50000'
//    },
// }
import { useSelector, useDispatch } from 'react-redux';
import { setCyberCoverage, setCheckedEndorsement } from '../../../../actions/application';
import { selectCyberCoverageLimit, selectCheckedEndorsements } from '../../../../selectors/application';
import { selectLoadingState } from '../../../../selectors';
import styled from 'styled-components';
import EndorsementCard from '../../EndorsementCard';
import UnderwritingRadioGroup from '../../shared/UnderwritingRadioGroup';
import CenteredLoadingSpinner from '../../../AddOns/shared/CenteredLoadingSpinner';
import { config, DEFAULT_LIMITS_OPTIONS } from './CyberInsurance.config';

const { endorsementKey: ENDORSEMENT_KEY, label: LABEL, description: DESCRIPTION } = config;

const CyberInsurance = () => {
  const dispatch = useDispatch();
  const isQuoteLoading = useSelector(selectLoadingState);
  const cyberLimit = useSelector(selectCyberCoverageLimit);
  const isSelected = useSelector(selectCheckedEndorsements).includes(ENDORSEMENT_KEY);

  const handleCheckboxChange = (checked: boolean) => {
    dispatch(setCheckedEndorsement(ENDORSEMENT_KEY, checked));

    const cyberValues = {
      limits: String(DEFAULT_LIMITS_OPTIONS[0].value),
    };
    // will call quote/bindable endpoint with updated endorsement limit through redux middleware
    dispatch(setCyberCoverage(checked ? cyberValues : null));
  };

  const handleLimitsChange = (newValue: string) => {
    // will call quote/bindable endpoint with updated endorsement limit through redux middleware
    dispatch(setCyberCoverage({ limits: newValue }));
  };

  return (
    <EndorsementCard
      endorsementKey={ENDORSEMENT_KEY}
      label={LABEL}
      description={
        <>
          <p>{DESCRIPTION}</p>
          <BoldText>Per Event Deductible: $1,000</BoldText>
        </>
      }
      isSelected={isSelected}
      onCheckboxChange={handleCheckboxChange}
      hasExpandableContent
    >
      <SubQuestionsContainer>
        {isQuoteLoading && <CenteredLoadingSpinner useAltColor />}
        <UnderwritingRadioGroup
          questionCopy="Select your coverage limit:"
          options={DEFAULT_LIMITS_OPTIONS}
          selectedValue={cyberLimit}
          onChange={handleLimitsChange}
          name="cyber-limits"
          isActive={!isQuoteLoading}
        />
      </SubQuestionsContainer>
    </EndorsementCard>
  );
};

const BoldText = styled.p`
  font-weight: 600;
`;

const SubQuestionsContainer = styled.div`
  position: relative;
`;

export default CyberInsurance;
